module.exports = __webpack_public_path__ + "static/media/ContactIcon.30d747d4.png";